export const DONGHO_SET_LIST_DATA = 'DONGHO_SET_LIST_DATA';
export const DONGHO_SET_LIST_META = 'DONGHO_SET_LIST_META';
export const DONGHO_TITLE = 'Dòng họ';